import {Component, Inject, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {AlertService, DataUtils, JhiLanguageService} from 'ng-jhipster';
import {Parametrage} from './parametrage.model';
import {ParametrageService} from './parametrage.service';
import {DOCUMENT} from '@angular/platform-browser';
import {JhiAlertComponent, Principal} from '../../shared';
import {CONSTANTS} from '../../cadens.constants';
import {TranslateService} from 'ng2-translate';
import {
    CategorieFormation,
    CategorieFormationService,
    Piece,
    PieceService,
    Question,
    QuestionService
} from '../formation';
import {Observable} from 'rxjs';
import {ListeChoixService} from '../../shared/ListeChoix/listeChoix.service';
import {ListeChoix} from '../../shared/ListeChoix/listeChoix.model';

@Component({
    selector: 'jhi-parametrage',
    templateUrl: './parametrage.component.html'
})
export class ParametrageComponent implements OnInit {

currentAccount: any;
    parametrages: Parametrage[];
    services: ListeChoix[];
    pieces: Piece[];
    questions: Question[];
    error: any;
    success: any;
    pageEdition: string;
    constants = CONSTANTS;
    public navIsFixed = true;
    currentLang: string;
    private categorieFormationId;
    isSaving = false;
    showAddParametre = false;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private jhiLanguageService: JhiLanguageService,
        private translate: TranslateService,
        private parametrageService: ParametrageService,
        private listeChoixService: ListeChoixService,
        private categorieFormationService: CategorieFormationService,
        private alertService: AlertService,
        private principal: Principal,
        private dataUtils: DataUtils,
        private pieceService: PieceService,
        private questionsService: QuestionService

    ) {
        this.jhiLanguageService.setLocations(['parametrage', 'formation', 'pieceJointe']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }

    ngOnInit() {
        this.isSaving = true;
        this.goToStep(CONSTANTS.GENERAL);
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang );
    }

    goToStep(step: string) {
        if (step === 'SERVICE') {
            this.listeChoixService.query({ type: 'SERVICE' }).subscribe(
                (res: Response) => {
                    this.services = res.json();
                    this.pageEdition = step;
                },
                (res: Response) => this.onError(res.json())
            );
        } else {
            this.parametrageService.query({rubrique: step.toUpperCase()}).subscribe(
                (res: Response) => {
                    this.convertToParamatrageArray(res.json());
                    this.showAddParametre = step === 'FAQ';
                    this.pageEdition = step;
                },
                (res: Response) => this.onError(res.json())
            );

            this.categorieFormationService.query({code: step}).subscribe(
                (res: Response) => {
                    let cats: CategorieFormation[] = res.json();
                    if (cats != null && cats.length > 0) {
                        this.categorieFormationId = cats[0].id;
                        this.LoadAll();
                    } else {
                        this.categorieFormationId = null;
                        this.pieces = null;
                        this.isSaving = false;
                    }
                });
        }
    }

    private convertToParamatrageArray(res: any) {
        let parametrages: Parametrage[] = res;
        let objectParametrages: Parametrage[] = [];
        parametrages.forEach(param => {
            if(param.objet === 'date' && param.libelle != null) {
                // Parse string to Date
                let dateParts = param.libelle.split("/");
                param.date = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
            }
            objectParametrages.push(Object.assign(new Parametrage(), param));
        });
        this.parametrages = objectParametrages;
    }

    addParametre() {
        let newParam = new Parametrage();
        newParam.rubrique = this.pageEdition;
        newParam.typeParam = 'QUESTION';
        newParam.page = this.pageEdition;
        this.parametrages.push(newParam);
    }

    private loadPieces() {
        let categorieFormationIdList: Number[] = [];
        categorieFormationIdList.push(this.categorieFormationId);
        this.pieceService.query({categorieFormationIdList: categorieFormationIdList}).subscribe(
            (res: Response) => {
                this.pieces = res.json();
                if (this.pieces == null) {
                    this.pieces = [];
                }
                this.isSaving = false;
            },
            (res: Response) => {
                this.onError(res);
                this.isSaving = false;
            });
    }

    private loadQuestions() {
        let categorieIdList: Number[] = [];
        categorieIdList.push(this.categorieFormationId);
        this.questionsService.query({categorieIdList: categorieIdList}).subscribe(
            (res: Response) => {
                this.questions = res.json();
                if (this.questions == null) {
                    this.questions = [];
                }
                this.isSaving = false;
            },
            (res: Response) => {
                this.onError(res);
                this.isSaving = false;
            });
    }

    private LoadAll() {

        this.loadPieces();
        this.loadQuestions();
    }


    save() {
        this.isSaving = true;
        this.parametrages.forEach(parametrage => {
           if(parametrage.objet === 'date') {
               parametrage.libelle = parametrage.date.toLocaleDateString();
           }
        });
        this.parametrageService.update(this.parametrages).subscribe(
            result => {
                this.convertToParamatrageArray(result);
                this.isSaving = false;
                this.alertService.success('cadensApp.parametrage.updated');
            }
        );
        if (this.categorieFormationId != null) {
            let updates = [];
            this.pieces.forEach(piece => piece.categorieFormationId = this.categorieFormationId);
            if (this.pieces != null && this.pieces.length > 0) {
                updates.push(this.pieceService.update(this.pieces));
            }
            this.questions.forEach(question => question.categorieFormationId = this.categorieFormationId);
            if (this.questions != null && this.questions.length > 0) {
                updates.push(this.questionsService.update(this.questions));
            }
            Observable.forkJoin(updates).subscribe((results: any[]) => {
                this.pieces = [];
                this.LoadAll();
                this.alertService.success('cadensApp.parametrage.updated');
            });
        }
    }
    cancel() {
        this.goToStep(this.pageEdition);
    }


    byteSize(field) {
        return this.dataUtils.byteSize(field);
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    }

    onError(response: Response) {
        JhiAlertComponent.onError(this.alertService, response);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/parametrage/parametrage.component.ts